import { gql } from "@apollo/client";

export const getPlaceItOfferMessages = gql`
  query Offer_messages($offerMessagesId: ID!) {
    offer_messages(id: $offerMessagesId) {
      uuid
      sender_name
      state
      timestamp
      message
    }
  }
`;
